/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { RealtimeRecognitionAlternative } from './realtime-recognition-alternative';

/**
 *
 * @export
 * @interface RealtimeRecognitionResult
 */
export interface RealtimeRecognitionResult {
  /**
   *
   * @type {Array<RealtimeRecognitionAlternative>}
   * @memberof RealtimeRecognitionResult
   */
  alternatives?: Array<RealtimeRecognitionAlternative>;
  /**
   *
   * @type {string}
   * @memberof RealtimeRecognitionResult
   */
  attaches_to?: RealtimeRecognitionResultAttachesToEnum;
  /**
   *
   * @type {string}
   * @memberof RealtimeRecognitionResult
   */
  channel?: string;
  /**
   *
   * @type {number}
   * @memberof RealtimeRecognitionResult
   */
  end_time: number;
  /**
   *
   * @type {boolean}
   * @memberof RealtimeRecognitionResult
   */
  is_eos?: boolean;
  /**
   *
   * @type {number}
   * @memberof RealtimeRecognitionResult
   */
  score?: number;
  /**
   *
   * @type {number}
   * @memberof RealtimeRecognitionResult
   */
  start_time: number;
  /**
   *
   * @type {string}
   * @memberof RealtimeRecognitionResult
   */
  type: RealtimeRecognitionResultTypeEnum;
}

export const RealtimeRecognitionResultAttachesToEnum = {
  Next: 'next',
  Previous: 'previous',
  None: 'none',
  Both: 'both',
} as const;

export type RealtimeRecognitionResultAttachesToEnum =
  typeof RealtimeRecognitionResultAttachesToEnum[keyof typeof RealtimeRecognitionResultAttachesToEnum];
export const RealtimeRecognitionResultTypeEnum = {
  Word: 'word',
  Punctuation: 'punctuation',
  SpeakerChange: 'speaker_change',
} as const;

export type RealtimeRecognitionResultTypeEnum =
  typeof RealtimeRecognitionResultTypeEnum[keyof typeof RealtimeRecognitionResultTypeEnum];
